import type { ResolvedFileCacheEntry } from './resolve-file-cache.js';

type ResolveResult = { path: string; size: number } | { error: string };

const inflightByKey = new Map<string, Promise<ResolveResult>>();

export function joinInflightResolve(
  cacheKey: string,
  factory: () => Promise<ResolveResult>,
): Promise<ResolveResult> {
  const existing = inflightByKey.get(cacheKey);
  if (existing != null) {
    return existing;
  }

  const promise = factory().finally(() => {
    if (inflightByKey.get(cacheKey) === promise) inflightByKey.delete(cacheKey);
  });
  inflightByKey.set(cacheKey, promise);
  return promise;
}

/** @internal Test helper. */
export function resetInflightResolveForTests(): void {
  inflightByKey.clear();
}

export type { ResolveResult };
